import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { MarketplacesColumnContainer } from '../../../containers/marketplaces-column-container';
import { messages } from './messages';

const MarketplacesColumn = ({ customerId }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  const marketplaces = customer?.marketplaces || [];

  if (!marketplaces.length || marketplaces.length > 1) {
    return '';
  }

  return <MarketplacesColumnContainer marketplaceId={marketplaces[0].marketplaceId} type='marketplaces' />;
};

export const Marketplaces = {
  getMessageDescriptor: () => messages.marketplaces,
  id: 'marketplaces',

  render: ({ customerId }) => {
    return <MarketplacesColumn customerId={customerId} />;
  },
};
